import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export const feesV2Client = axios.create({
  baseURL: readFromEnv(Env.LogisticsFeesServiceUrlV2),
})
